'use client';

import { useHreflang } from '@/src/shared/presentation/hooks/use-hreflang';
import { getPathnameWithLocale, locales } from '@/src/shared/utils/i18n';

import css from './language-switcher.css';

export function LanguageSwitcher() {
  const { hrefLangMap } = useHreflang();

  return (
    <div className={css.wrapper}>
      {locales.map((locale, index) => {
        const href = hrefLangMap[locale] || getPathnameWithLocale(locale, '/');

        return (
          <div className={css.item} key={locale}>
            <a href={href} className={css.a}>
              {locale.toUpperCase()}
            </a>

            {index < locales.length - 1 && <div className={css.separator} />}
          </div>
        );
      })}
    </div>
  );
}
